export default "__VITE_ASSET__BUvbFjlL__"